export default __webpack_public_path__ + "static/media/seller-private.7bef9649.png";